import {LogOut} from 'lucide-react';
import * as React from 'react';
import {clearStoredTrail} from 'src/Breadcrumbs';
import {clearRevealed} from 'src/NetWorthView/useRevealed';
import {MenuButton} from 'src/SideNav/MenuItem';

export const logout = () => {
  clearStoredTrail();
  clearRevealed();
  // Server route from the BFF auth middleware: clears the session cookie
  // and the Auth0-side session, then returns to the app origin.
  window.location.assign('/logout');
};

const LogoutButton = () => (
  <MenuButton iconLeft={<LogOut />} onClick={logout} label="Logout" />
);

export default LogoutButton;
